import React from 'react'
import { Button, TextField } from '@material-ui/core'
import { strings } from '../../../localization/strings'
import moment from 'moment'

const styles = {
    content: {
        padding: '20px 8px',
        margin: 'auto',
        maxWidth: 700,
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    cell: {
        flexGrow: 1,
        padding: 10,
        maxWidth: 200,
        width: '100%',
    },
}

class Component extends React.Component {
    state = {
        dateFrom: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
    }

    handleSubmit = () => {
        let { dateFrom, dateTo } = this.state
        this.props.handleSubmit(dateFrom, dateTo)
    }

    render() {
        let { handleSubmit } = this
        let { dateFrom, dateTo } = this.state

        return (
            <div style={styles.content}>
                <div style={styles.row}>
                    <div style={styles.cell}>
                        <TextField
                            label={strings.movements_dateFrom}
                            type="date"
                            defaultValue={dateFrom}
                            onChange={(x) =>
                                this.setState({ dateFrom: x.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </div>

                    <div style={styles.cell}>
                        <TextField
                            label={strings.movements_dateTo}
                            type="date"
                            defaultValue={dateTo}
                            onChange={(x) =>
                                this.setState({ dateTo: x.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </div>

                    <div style={styles.cell}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            disabled={this.state.fetching_orders}
                        >
                            {strings.movements_search}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Component
